<script>
	import { createEventDispatcher } from "svelte";

	export let options = [];
	export let value;
	export let label = null;
	export let id = undefined;

	const dispatch = createEventDispatcher();
</script>

<!-- svelte-ignore a11y-no-onchange -->
<select
	class="form-control"
	{id}
	bind:value
	on:change|preventDefault|stopPropagation={() => dispatch("input", value)}
>
	{#if label}
		<option value="">{label}</option>
	{/if}

	{#if typeof options[0] === "string" || typeof options[0] === "number"}
		{#each options as option}
			<option value={option}>{option}</option>
		{/each}
	{/if}

	{#if typeof options[0] === "object" && options[0].name !== undefined && options[0].value !== undefined}
		{#each options as { name, value }}
			<option {value}>{name}</option>
		{/each}
	{/if}
</select>

<style>
	select {
		display: block;
		width: 100%;
	}
</style>
